module.exports = __webpack_public_path__ + "static/media/duvidas-sobre-como-comprar-imovel-mobile.4f859706.png";